import { render, staticRenderFns } from "./VerticalList.vue?vue&type=template&id=5b2c5cb4&scoped=true"
import script from "./VerticalList.vue?vue&type=script&lang=js"
export * from "./VerticalList.vue?vue&type=script&lang=js"
import style0 from "./VerticalList.vue?vue&type=style&index=0&id=5b2c5cb4&prod&scoped=true&lang=css"
import style1 from "./VerticalList.vue?vue&type=style&index=1&id=5b2c5cb4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2c5cb4",
  null
  
)

export default component.exports